//////////////////
// IMPORTS
//////////////////
// libraries
import Radium from "radium";
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

import IChromeSlackWrapper from "./ChromeSlackWrapper.d";
import { ChromeSlackVerifier } from "../chrome-slack-verifier";
import { chromeSlackWrapperFragments, chromeSlackWrapperQuery } from "./ChromeSlackWrapper.gql";
import { page, PageEvents } from "@util/analytics.util";
import { withRouteQuery } from "@routing/routes.util";

import ReduxState from "../../declarations/state.d";

//////////////////
// COMPONENT
//////////////////
@Radium
class ChromeSlackWrapperCmpt extends React.Component<IChromeSlackWrapper.Props, any> {
  public render() {
    return <ChromeSlackVerifier viewer={this.props.viewer} />;
  }

  public componentDidMount() {
    page(PageEvents.CHROME_SLACK_VERIFIER);
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: ReduxState.Redux, _ownProps: IChromeSlackWrapper.Props) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {})(ChromeSlackWrapperCmpt);

//////////////////
// RELAY
//////////////////

export const ChromeSlackWrapper = createFragmentContainer<IChromeSlackWrapper.Props>(
  reduxContainer,
  chromeSlackWrapperFragments,
);

export const ChromeSlackWrapperPage = withRouteQuery(ChromeSlackWrapper, chromeSlackWrapperQuery);
